// Lightweight JS pack for the white-label login screen. The `login` layout has
// no admin JS, so we boot a minimal Stimulus app with just the login controller.
import { Application } from "stimulus";
import LoginController from "../controllers/login_controller";

const application = Application.start();
application.register("login", LoginController);
